const getParamsValueFromUrl = (key) => {
  const url = window.location.href;
  const name = key.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line no-useless-escape
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getPaginationCursorFromLoadMoreButtonHref = () => {
  const moreButton = document.querySelector('.js-new-arrival-list-article-more-button');
  if (!moreButton) return null;
  const url = new URL(moreButton.getAttribute('href'));
  return url.searchParams.get('pagination_cursor');
};

export const createDataObject = (pageType, store, config) => {
  const data = {
    page: store.nextPage,
    type: pageType,
    v: '',
    sub: '',
    lv2: '',
    locate: '',
    limit: config.pageNum,
    random: new Date().getTime()
  };

  if (data.type === 'search') {
    data.v = getParamsValueFromUrl('search_word');
  } else if (data.type === 'main_category') {
    data.v = location.pathname.split('/')[1];
  } else if (data.type === 'newarrival_db') {
    data.pagination_cursor = getPaginationCursorFromLoadMoreButtonHref();
  }

  return data;
};
